import styled from 'styled-components';

export const Loader = styled.div<{ width?: number; height?: number }>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:after {
    content: ' ';
    display: block;
    width: ${({ width }) => width || 30}px;
    height: ${({ height }) => height || 30}px;
    border-radius: 50%;
    border: 4px solid #2ac4fb;
    border-color: #2ac4fb transparent #2ac4fb transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }

  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
